import { StyleSheet, Dimensions } from 'react-native';
import { PALETTE } from '../../../../constants';

const WINDOW_WIDTH = Dimensions.get('window').width;

export default StyleSheet.create({
  container: {
    backgroundColor: 'transparent',
    marginHorizontal: 10,
    paddingTop: 14,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },
  transactionSummary: {
    marginTop: 20,
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  }

});
